import React from 'react'
import IndividualResourcePrintControlsComponent from './component'

const IndividualResourcePrintControls = () => {
  return <IndividualResourcePrintControlsComponent />
}

export default IndividualResourcePrintControls
